import 'jquery';

$(function () {
    const forms = $('.form');
    const neighborhoodSelect = $('#neighborhoodSelect');

    if (neighborhoodSelect.length > 0) {
        neighborhoodSelect.on('change', function (e) {
            const url = $(this).val();
            if (url) {
                window.location = url;
            }
        });
    }
    // Handle search submit
    const searchForm = $('.myhistory-map-search');

    if (searchForm.length > 0) {
        searchForm.on('submit', doMyHistorySearch);
    }

    function doMyHistorySearch() {
        var keyword = encodeURIComponent($('#myhistory-search-keyword').val());
        var searchterm = [];
        var mode = [];
        var conn = [];
        var field = [];

        // Add keyword with AND connector
        if (keyword) {
            searchterm.push(keyword);
            field.push('all');
            mode.push('all');
            conn.push('and');
        }

        // Get the checked formats and split on the | symbol
        var formats = [];
        var formats_checked = $('#myhistory-search-params input:checked').each(function () {
            var values = $(this).val().split('|');
            values.forEach((value) => {
                return formats.push(value);
            });
        });

        field.push('format');
        mode.push('any');
        conn.push('and');
        // Add space-separated formats
        searchterm.push(encodeURIComponent(formats.join(' ')));

        var url = 'https://digital-collections.columbuslibrary.org/digital/search';
        if (formats && formats.length) {
            url =
                url +
                '/searchterm/' +
                searchterm.join('!') +
                '/field/' +
                field.join('!') +
                '/mode/' +
                mode.join('!') +
                '/conn/' +
                conn.join('!') +
                '/order/nosort';
        } else {
            url = url + '/searchterm/' + keyword + '/order/nosort';
        }
        document.location.href = url;
        return false;
    }

    // Handle outside collection click
    $('.view-myhistory-terms .collection a').bind('click', function () {
        var title = $(this).text();
        var collection = $(this).parents('.collection');
        $('.collection.active').not(collection).removeClass('active');
        $(collection).addClass('active');
        var html =
            '<h3 class="views-title">' +
            title +
            '</h3>' +
            $(collection).find('.view-display-id-block_collection').html();

        if ($('#collection-detail').length == 0) {
            $('<div id="collection-detail"></div>').insertAfter('.view-id-myhistory_terms.view-display-id-page');
        }

        $('#collection-detail').html(html);

        // Scroll to the detail
        $('html, body').animate(
            {
                scrollTop: $('#collection-detail').offset().top,
            },
            1000
        );

        return false;
    });
});
